import React from 'react';
import { Chart } from 'primereact/chart';
import { Badge } from 'primereact/badge';
import MlxBlockUI from '../../../../components/common/MlxBlockUI/MlxBlockUI';

interface StaffByLocationProps {
    data: any;
    utilizationData: any;
}

const StaffByLocation: React.FC<StaffByLocationProps> = ({ data, utilizationData }) => {
    const chartOptions = {
        indexAxis: 'y' as const,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                beginAtZero: true,
                max: 100,
                ticks: {
                    callback: function (value: any) {
                        return value + '%';
                    },
                },
            },
            y: {
                grid: {
                    display: false,
                },
            },
        },
    };

    return (
        <MlxBlockUI>
            <div className="dashboard-card dashboard-card-wrapper coming-soon-card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Staff by Location</h5>
                    <i className="ri-map-pin-line"></i>
                </div>
                <div className="card-body">
                    <div className="chart-container" style={{ height: '300px' }}>
                        <Chart type="bar" data={data} options={chartOptions} />
                    </div>

                    <div className="mt-4">
                        <h6 className="mb-3">Staff Utilization</h6>
                        <div className="row">
                            {utilizationData.map((item: any, index: number) => (
                                <div key={index} className="col-md-6 mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center">
                                            <div
                                                className="location-indicator me-2"
                                                style={{
                                                    width: '12px',
                                                    height: '12px',
                                                    borderRadius: '50%',
                                                    backgroundColor: item.color,
                                                }}
                                            ></div>
                                            <span className="location-name">{item.location}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            <Badge
                                                value={`${item.utilization}%`}
                                                severity={
                                                    item.utilization >= 80 ? 'success' : item.utilization >= 60 ? 'warning' : 'danger'
                                                }
                                            />
                                            <span className="staff-count text-muted">{item.staffCount} staff</span>
                                        </div>
                                    </div>
                                    <div className="progress mt-2" style={{ height: '6px' }}>
                                        <div
                                            className="progress-bar"
                                            style={{
                                                width: `${item.utilization}%`,
                                                backgroundColor: item.color,
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="mt-4 pt-3 border-top">
                        <div className="row text-center">
                            <div className="col-4">
                                <div className="metric-value">
                                    {utilizationData.reduce((total: number, item: any) => total + item.staffCount, 0)}
                                </div>
                                <div className="metric-label text-muted">Total Staff</div>
                            </div>
                            <div className="col-4">
                                <div className="metric-value">
                                    {Math.round(
                                        utilizationData.reduce((total: number, item: any) => total + item.utilization, 0) /
                                            utilizationData.length
                                    )}
                                    %
                                </div>
                                <div className="metric-label text-muted">Avg Utilization</div>
                            </div>
                            <div className="col-4">
                                <div className="metric-value">{utilizationData.filter((item: any) => item.utilization >= 80).length}</div>
                                <div className="metric-label text-muted">High Utilization</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MlxBlockUI>
    );
};

export default StaffByLocation;
